// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SpecificationInput_inputContainer__uepye","title":"SpecificationInput_title__S6Yv3"};